// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__qfKoh","mainDiv":"secondFold_mainDiv__G2Tla","heading":"secondFold_heading__VX6oE"};